import React, {useEffect, useState} from 'react';
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import SingleSelectUserRole from "../../../components/common/UserSelect/SingleSelectUserRole";
import ModalShell from "../../../components/common/Modals/ModalShell";

const AssignCorporateUserModal: React.FC<ModalProps> = ({open, setOpen, selected, setSelected}) => {
    const [selectedUser, setSelectedUser] = useState<any>(null);

    useEffect(() => {
        if (selected) setSelectedUser(selected);
    }, [selected,setSelectedUser]);

    const handleConfirm = () => {
        setSelected(selectedUser);
        handleClose();
    }

    const handleReset = () => {
        setSelectedUser(null);
    }

    const handleClose = ()=> {
        handleReset();
        setOpen(false);
    }

    return (
      <ModalShell
        open={open}
        onClose={handleClose}
        title="Assign user as corporate"
        subtitle={<>This action will change the selected user's role to <strong>corporate</strong>.</>}
        actions={
          <>
            <button className="btn" onClick={handleClose}>Cancel</button>
            <button className="btn btn-primary" onClick={handleConfirm}>Confirm</button>
          </>
        }
      >
        <div className="dlg-section">
          <span className="dlg-label">Add user to the corporate role</span>
          <SingleSelectUserRole selectedUser={selectedUser} setSelectedUser={setSelectedUser} />
        </div>
      </ModalShell>
  )
};

export default AssignCorporateUserModal;